import axios from 'axios';

// Function to search CEP using the BrasilAPI
export const searchCep = async (cep) => {
  try {
    // Remove any non-digit characters from the CEP
    const cleanCep = cep.replace(/\D/g, '');
    
    // Check if the CEP has 8 digits
    if (cleanCep.length !== 8) {
      return { error: 'CEP deve conter 8 dígitos' };
    }
    
    // Make the API request
    const response = await axios.get(`https://brasilapi.com.br/api/cep/v2/${cleanCep}`);
    
    // Return the address data
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Error fetching CEP:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Erro ao buscar CEP'
    };
  }
};